import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PromoterForm.html?raw';
import lang from 'dojo/_base/lang';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { VAM2types, VAMclassNames } from "../../../_loadingHelpers/VAMv2Types";
import HintBox from '../../../../moreCore/UI/EntityBased/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import SearchSelect from '../../../../moreCore/UI/SearchSelect/SearchSelect';

class PromoterForm extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private input_AccountingType: MdsLax<InstanceType<typeof HintBox>>;
    private input_PriceGroup: MdsLax<InstanceType<typeof HintBox>>;
    private input_AddressForDispatch: MdsLax<InstanceType<typeof HintBox>>;
    private input_ContactPersonForDispatch: MdsLax<InstanceType<typeof SearchSelect>>;

    private _timeoutHandler;

    isValid(): boolean {
        if (this.input_AccountingType.getValue() == null) return false;
        if (this.input_PriceGroup.getValue() == null) return false;

        return true;
    }
    prepareView() {

        this.updateContactPersonForDispatch();
    }

    private updateContactPersonForDispatch() {

        let address: VAM2types.Entity_gDisp = this.getAttributeValue("ref_address_for_dispatch");
        let preset = this.getAttributeValue("ref_contact_person_dispatch");

        if (!address || (address.Classname != VAMclassNames.organisations_external && address.Classname != VAMclassNames.organisations_internal)) {

            this.disableNode(this.input_ContactPersonForDispatch);
            this.input_ContactPersonForDispatch._setPlaceholderAttr(this.translate("PromoterForm_ContactPersonForDispatch_Placeholder_disabled"));
            this.setAttributeValue("ref_contact_person_dispatch", null);
            this.UiModder.domClass.remove(this.input_ContactPersonForDispatch.domNode, "ego_animated_progressBar");
        } else {

            if (address.Classname != VAMclassNames.organisations_external && address.Classname != VAMclassNames.organisations_internal) {

                this.UiModder.domClass.remove(this.input_ContactPersonForDispatch.domNode, "ego_animated_progressBar");
                return
            }

            
            this.RequestManager.callfunction(
                "Webtool_API__ProjectWizard_InvolvedAddresses_GetContactPersonListForDispatch",
                { addressID: address.ID },
                (response: Array<VAM2types.Entity_gDisp>) => {

                    this.input_ContactPersonForDispatch.setData(preset, response);
                    
                    this.disableNode(this.input_ContactPersonForDispatch, false);
                    this.input_ContactPersonForDispatch._setPlaceholderAttr(this.translate("PromoterForm_ContactPersonForDispatch_Placeholder"));
                    this.UiModder.domClass.remove(this.input_ContactPersonForDispatch.domNode, "ego_animated_progressBar");
                },
                (err) => {
                    this._showErrorMessage(err.Message);
                    this.disableNode(this.input_ContactPersonForDispatch);
                    this.input_ContactPersonForDispatch._setPlaceholderAttr(this.translate("PromoterForm_ContactPersonForDispatch_Placeholder_disabled"));
                    this.UiModder.domClass.remove(this.input_ContactPersonForDispatch.domNode, "ego_animated_progressBar");
                }
            )
        }
    }

    private _onChangeAccountingType() {

    }

    private _onChangePriceGroup() {

    }

    private _onChangeAddressForDispatch() {

        if (this._timeoutHandler) clearTimeout(this._timeoutHandler);
        this.UiModder.domClass.add(this.input_ContactPersonForDispatch.domNode, "ego_animated_progressBar");
        this._timeoutHandler = setTimeout(lang.hitch(this, this.updateContactPersonForDispatch), 150);
    }

    private _onClick_OpenSED(mode, evt) {
        this.loadSelectEntityDialog(evt,
            mode,
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<any>>) {

        if (!items || !items.length) return;
        let entity = items[0].entry.data;
        switch (mode) {
            case "selectAccountingType":
                this.setAttributeValue("ref_accounting_type", entity);
                break;
            case "selectPriceGroup":
                this.setAttributeValue("ref_pricegroup", entity);
                break;
            case "selectAddressForDispatch":
                this.setAttributeValue("ref_address_for_dispatch", entity);
                break;
            default:
                this._showErrorMessage(`Wrong SelectEntityDialogMode - '${mode}''`)
        }
    }
    private _showErrorMessage(msg?: string) {
        var errorMessage = msg ? msg : "...error occured";
        this.showToast(errorMessage, "fas fa-exclamation-triangle");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__ProjectWizard__InvolvedAddresses_SED_GetConfig";
        this.input_AccountingType.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectAccountingType"));
        this.input_PriceGroup.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectPriceGroup"));
        this.input_AddressForDispatch.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectAddressForDispatch"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PromoterForm);